// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Hero jumbotron ── */

.login-page {
  display: flex;
  flex-direction: column;
  /* Leave room for the fixed navbar (84px offset on main) and the app footer
     (~64px) so the privacy / user-agreement links stay above the fold. */
  min-height: calc(100vh - 148px);
}

.login-hero {
  background: #f2f7f6;
  border-bottom: 1px solid #dce8e6;
  padding: 3rem 1.5rem 2.75rem;
  text-align: center;
}

.login-hero-inner {
  max-width: 620px;
  margin: 0 auto;
}

.login-hero-heading {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  color: rgb(0, 51, 51);
  line-height: 1.45;
  margin-bottom: 1.25rem;
}

.login-hero-lead {
  font-size: 0.9rem;
  color: #4b5563;
  line-height: 1.7;
  margin: 0;
}

/* ── Auth link rows ── */

.auth-links {
  border-top: 1px solid #e5e7eb;
  padding-top: 0;
}

.auth-link-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 0;
}

.auth-link-row + .auth-link-row {
  border-top: 1px solid #f3f4f6;
}

.auth-link-prompt {
  font-size: 0.82rem;
  color: #6b7280;
}

.auth-link-btn {
  font-size: 0.82rem;
  font-weight: 600;
  color: rgb(0, 51, 51);
  text-decoration: none;
}

.auth-link-btn:hover {
  text-decoration: underline;
  color: rgb(0, 51, 51);
}

/* ── Trust signals ── */

.login-trust {
  padding: 1.75rem 1.5rem 2.5rem;
  text-align: center;
}

.login-trust-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.76rem;
  color: #9ca3af;
  margin-bottom: 0.55rem;
  line-height: 1.4;
}

.login-trust-item:last-child {
  margin-bottom: 0;
}

.login-trust-icon {
  color: rgb(0, 51, 51);
  opacity: 0.5;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,aAAa;EACb,sBAAsB;EACtB;yEACuE;EACvE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,yBAAyB;;AAEzB;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,wBAAwB;;AAExB;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB","sourcesContent":["/* ── Hero jumbotron ── */\n\n.login-page {\n  display: flex;\n  flex-direction: column;\n  /* Leave room for the fixed navbar (84px offset on main) and the app footer\n     (~64px) so the privacy / user-agreement links stay above the fold. */\n  min-height: calc(100vh - 148px);\n}\n\n.login-hero {\n  background: #f2f7f6;\n  border-bottom: 1px solid #dce8e6;\n  padding: 3rem 1.5rem 2.75rem;\n  text-align: center;\n}\n\n.login-hero-inner {\n  max-width: 620px;\n  margin: 0 auto;\n}\n\n.login-hero-heading {\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  color: rgb(0, 51, 51);\n  line-height: 1.45;\n  margin-bottom: 1.25rem;\n}\n\n.login-hero-lead {\n  font-size: 0.9rem;\n  color: #4b5563;\n  line-height: 1.7;\n  margin: 0;\n}\n\n/* ── Auth link rows ── */\n\n.auth-links {\n  border-top: 1px solid #e5e7eb;\n  padding-top: 0;\n}\n\n.auth-link-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.65rem 0;\n}\n\n.auth-link-row + .auth-link-row {\n  border-top: 1px solid #f3f4f6;\n}\n\n.auth-link-prompt {\n  font-size: 0.82rem;\n  color: #6b7280;\n}\n\n.auth-link-btn {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: rgb(0, 51, 51);\n  text-decoration: none;\n}\n\n.auth-link-btn:hover {\n  text-decoration: underline;\n  color: rgb(0, 51, 51);\n}\n\n/* ── Trust signals ── */\n\n.login-trust {\n  padding: 1.75rem 1.5rem 2.5rem;\n  text-align: center;\n}\n\n.login-trust-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  font-size: 0.76rem;\n  color: #9ca3af;\n  margin-bottom: 0.55rem;\n  line-height: 1.4;\n}\n\n.login-trust-item:last-child {\n  margin-bottom: 0;\n}\n\n.login-trust-icon {\n  color: rgb(0, 51, 51);\n  opacity: 0.5;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
